import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import {
  isMetaPixelConfigured,
  trackMetaPageView,
} from '../analytics/metaPixel';

/**
 * Dispara PageView do Meta Pixel em cada navegação client-side (SPA).
 * Evita duplicata no mesmo URL quando o React StrictMode reexecuta efeitos em dev.
 */
const MetaPixelRouteTracker: React.FC = () => {
  const location = useLocation();
  const lastTrackedKeyRef = useRef<string | null>(null);

  useEffect(() => {
    if (!isMetaPixelConfigured()) return;

    const key = `${location.pathname}${location.search}${location.hash}`;
    if (lastTrackedKeyRef.current === key) return;
    lastTrackedKeyRef.current = key;

    trackMetaPageView();
  }, [location.pathname, location.search, location.hash]);

  return null;
};

export default MetaPixelRouteTracker;
